// DO NOT EDIT this file was generated with scripts/IntrinsicElements
import * as React from "react";

export interface FuroSplitView extends React.HTMLAttributes<HTMLElement> {
  // no events defined.
  // properties

  // attributes

  // undocumented
  reverse?: boolean;
}

declare module "react" {
  namespace JSX {
    interface IntrinsicElements {
      /**
       * `furo-split-view`
       * is a layout component to visualise main / detail views (left right layout for master detail views).
       * You can add the attribute scroll on the detail view to make the content scrollable.
       *
       * ```html
       * <furo-split-view>
       * <div slot="master">Master</div>
       * <big-component scroll> </big-component>
       * </furo-split-view>
       * ```
       */
      "furo-split-view": FuroSplitView;
    }
  }
}
